export default "__VITE_ASSET__2152e896__"